<div class="modal-backdrop" *ngIf="isVisible" (click)="hide()">
  <div class="modal-container" [ngClass]="modalName" (click)="$event.stopPropagation()">
    
    <app-mitre-modal-content (hideModal)="hide()"
      [modalTitle]="modalTitle"
      [titleTemplateRef]="titleTemplateRef"
      [contentTemplateRef]="contentTemplateRef"
      [technique]="technique"
      [currentTactic]="currentTactic">
    </app-mitre-modal-content>

  </div>
</div>

<ng-template #title>
  <ng-content select=".custom-modal-header"></ng-content>
</ng-template>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
